import { isNotEmpty } from 'utils/ArrayUtils';
import { createDataPairValue } from 'utils/DataPairUtils';
import { addMyRecentPickedEntity } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/RecentPickedEntityService';
import { setValue } from '@decisions/server/DecisionsFramework/Design/Properties/ContextProviderService';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';

export function getPickedEntityId(node: ContextProviderNode): string | null {
  let pickedEntityId: string | null = null;
  let value = node.Value.OutputValue;

  if (typeof value === 'string') {
    pickedEntityId = value;
  } else if (typeof value === 'object' && value !== null) {
    // const type: $D.Framework.Design.Flow.Mapping.DecisionsType
    pickedEntityId = value.Descriptor;
  } else {
    pickedEntityId = null;
  }

  return pickedEntityId;
}

export async function submit(editingContext: string, path: string[], elementId?: string) {
  if (isNotEmpty(path)) {
    if (elementId) {
      await addMyRecentPickedEntity({
        entityId: elementId,
      });
    }

    const value = createDataPairValue(elementId);

    await setValue({
      contextProviderRegistrationId: editingContext,
      path: path,
      value,
    });
  }
}

export async function clear(editingContext: string, path: string[]) {
  return await submit(editingContext, path, undefined);
}
